import React from 'react';
import { render } from 'react-dom';
import createHistory from 'history/createHashHistory';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'react-router-redux';
import 'react-html5video/dist/styles.css';
import 'react-datepicker/dist/react-datepicker-cssmodules.css';
import 'react-toastify/dist/ReactToastify.min.css';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import routes from 'routes';
import store from './store';
import './index.css';
import './scss/common.scss';// to import local scss fle


if (!window) {
  window = global;
}

const history = createHistory();

/* commit purpose */

render((
  <MuiThemeProvider muiTheme={getMuiTheme()}>
    <Provider store={store}>
      <ConnectedRouter history={history}>
        {routes}
      </ConnectedRouter>
    </Provider>
  </MuiThemeProvider>),
  document.getElementById('root'),
);




// WEBPACK FOOTER //
// ./src/index.js